import React from "react";
import { cn } from "@gettactic/helpers";
import { Stack } from "@cmp-src/primitives";

export const WizardModalStepWrapper: React.FC<
  React.PropsWithChildren<{ className?: string }>
> = ({ children, className }) => {
  return <Stack className={cn("-mx-6", className)}>{children}</Stack>;
};
